import React from "react";
import { skillsSection } from "../data/data";

const skill = skillsSection.skills.find((s) => s.id === "ecommerce");

const SkillEcommerce = () => (
  <div className="skill-details-content">
    {/* <h4>{skill.title}</h4> */}
    <p>{skill.details}</p>
  </div>
);

export default SkillEcommerce;
